<script lang="ts">
  import Device from 'svelte-device-info';
  import { WindowsCustomEventTypes } from '../enums/windows-custom-event.enum';
  import { ConfigStore } from '../store/config';

  import { _ } from 'svelte-i18n';
  import TogglerFullscreenTheme from './themes/toggler-fullscreen-theme.svelte';
  import { HeaderThemeType } from '../enums/themes/header-theme-type.enum';
  import MultiOptionTheme from './themes/multi-option-theme.svelte';
  import { state_headerHeight, state_showContactForm } from '../store/state';
  import { afterUpdate } from 'svelte';
  import SvgIcon from './svg-icon.svelte';
  $: logoSrc = getLogoImg;
  let headerHeight: number = 0;
  let isErrorImage = false;

  const getLogoImg = (): string => {
    if ($ConfigStore.agentImg) return $ConfigStore.agentImg;

    if ($ConfigStore.logoMini?.length) {
      if ($ConfigStore.logoMini?.substring(0, 4) == 'http')
        return $ConfigStore.logoMini;

      return (
        ($ConfigStore.assetBaseUrl || $ConfigStore.apiBaseUrl) +
        $ConfigStore.logoMini
      );
    }

    if ($ConfigStore.logoMain?.length) {
      if ($ConfigStore.logoMain?.substring(0, 4) == 'http')
        return $ConfigStore.logoMain;

      return (
        ($ConfigStore.assetBaseUrl || $ConfigStore.apiBaseUrl) +
        $ConfigStore.logoMain
      );
    }

    return '';
  };

  const handleGoBackEmailForm = () => {
    window.dispatchEvent(
      new CustomEvent(WindowsCustomEventTypes.toggleContactForm, {
        detail: true,
      })
    );
  };

  afterUpdate(() => {
    state_headerHeight.set(headerHeight);
  });

  const handleErrorImage = () => {
    isErrorImage = true
  }
</script>

<div
  bind:offsetHeight={headerHeight}
  class="cs-cb-header cs-cb-header-{$ConfigStore.widgetType}"
  style:background={$ConfigStore.customTheme.headerBg}
  style:color={$ConfigStore.customTheme.headerTextColor}
>
  {#if $ConfigStore.showContactWindow && !$state_showContactForm}
    <button
      class="cs-cb-back-contact-form"
      aria-label={$_('contact_window.title')}
      on:click={handleGoBackEmailForm}
    >
      <svg
        width="13"
        height="13"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.835 3.86961L16.055 2.09961L6.16504 11.9996L16.065 21.8996L17.835 20.1296L9.70504 11.9996L17.835 3.86961Z"
          fill="currentColor"
        />
      </svg>
    </button>
  {/if}
  {#if logoSrc()?.length}
    {#if !isErrorImage}
    <div class="cs-cb-img">
      <img src={logoSrc()} alt={$ConfigStore.productName} on:error={handleErrorImage} />
    </div>
    {/if}
  {:else}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="974"
      height="803"
      class="cs-cb-default-img"
      viewBox="0 0 974 803"
    >
      <defs>
        <filter
          id="filter"
          x="21"
          y="22.969"
          width="487"
          height="650.343"
          filterUnits="userSpaceOnUse"
        >
          <feFlood result="flood" flood-color="#555" />
          <feComposite result="composite" operator="in" in2="SourceGraphic" />
          <feBlend result="blend" in2="SourceGraphic" />
        </filter>
        <filter
          id="filter-2"
          x="156.875"
          y="29.344"
          width="795.406"
          height="745.656"
          filterUnits="userSpaceOnUse"
        >
          <feFlood result="flood" flood-color="#2696c1" />
          <feComposite result="composite" operator="in" in2="SourceGraphic" />
          <feBlend result="blend" in2="SourceGraphic" />
        </filter>
        <filter
          id="filter-3"
          x="332"
          y="318"
          width="101"
          height="101"
          filterUnits="userSpaceOnUse"
        >
          <feFlood result="flood" flood-color="#fff" />
          <feComposite result="composite" operator="in" in2="SourceGraphic" />
          <feBlend result="blend" in2="SourceGraphic" />
        </filter>
        <filter
          id="filter-4"
          x="496"
          y="318"
          width="101"
          height="101"
          filterUnits="userSpaceOnUse"
        >
          <feFlood result="flood" flood-color="#fff" />
          <feComposite result="composite" operator="in" in2="SourceGraphic" />
          <feBlend result="blend" in2="SourceGraphic" />
        </filter>
        <filter
          id="filter-5"
          x="659"
          y="318"
          width="101"
          height="101"
          filterUnits="userSpaceOnUse"
        >
          <feFlood result="flood" flood-color="#fff" />
          <feComposite result="composite" operator="in" in2="SourceGraphic" />
          <feBlend result="blend" in2="SourceGraphic" />
        </filter>
      </defs>
      <g id="Artboard_1" data-name="Artboard 1">
        <g style="fill: #e30000; filter: url(#filter)">
          <path
            id="path-2"
            style:fill={$ConfigStore.customTheme.badgeIconColor}
            class="cls-1"
            d="M508,638l-79,9L210,671S32.511,705.581,21,508V181S24.261-10.169,241,28L507,78l-2,7Z"
            style="stroke: var(--cs-text-header-color); filter: none; fill: inherit; stroke-width: 19px;"
          />
        </g>
        <use
          xlink:href="#path-2"
          style="stroke: #000; filter: none; fill: none"
        />
        <g style="fill: #e30000; filter: url(#filter-2)">
          <path
            id="path"
            style:fill={$ConfigStore.customTheme.badgeBg}
            class="cls-2"
            d="M547,775l36-107s6.918-9.187-11-11-252-28-252-28-162.755-8.812-163-159,0-191,0-191-7.467-135,152-164S761,31,761,31,951.341,0,952,206s0,322,0,322S928.3,696,769,678l-24-2s-16.691-7-38,6S547,775,547,775Z"
            style="stroke: var(--cs-text-header-color); filter: none; fill: inherit; stroke-width: 19px;"
          />
        </g>
        <use
          xlink:href="#path"
          style="stroke: #000; filter: none; fill: none"
        />
        <g style="fill: #e30000; filter: url(#filter-3)">
          <circle
            id="circle-3"
            class="cls-3"
            cx="382.5"
            cy="368.5"
            r="50.5"
            style="stroke: inherit; filter: none; fill: inherit"
          />
        </g>
        <use
          xlink:href="#circle-3"
          style="stroke: #000; filter: none; fill: none"
        />
        <g style="fill: #e30000; filter: url(#filter-4)">
          <circle
            id="circle-2"
            class="cls-4"
            cx="546.5"
            cy="368.5"
            r="50.5"
            style="stroke: inherit; filter: none; fill: inherit"
          />
        </g>
        <use
          xlink:href="#circle-2"
          style="stroke: #000; filter: none; fill: none"
        />
        <g style="fill: #e30000; filter: url(#filter-5)">
          <circle
            id="circle"
            class="cls-5"
            cx="709.5"
            cy="368.5"
            r="50.5"
            style="stroke: inherit; filter: none; fill: inherit"
          />
        </g>
        <use
          xlink:href="#circle"
          style="stroke: #000; filter: none; fill: none"
        />
      </g>
    </svg>
  {/if}

  <div class="cs-cb-info">
    {#if $ConfigStore.agentName?.length}
      <div class="cs-agent-name" role="heading" aria-level="1">
        {$ConfigStore.agentName}
      </div>
    {/if}
    {#if $ConfigStore.agentTagline?.length}
      <div class="cs-agent-headline" role="heading" aria-level="2">
        {$ConfigStore.agentTagline}
      </div>
    {/if}
  </div>
  {#if $ConfigStore.headerCustomHtml?.length > 0}
    <div class="cs-cb-external">
      {@html $ConfigStore.headerCustomHtml}
    </div>
  {/if}
  <div
    class="cs-cb-action cs-cb-action-{$ConfigStore.customTheme.headerThemeType}"
  >
    {#if !Device.isPhone && $ConfigStore.customTheme.headerThemeType === HeaderThemeType.toggle}
      <TogglerFullscreenTheme />
    {/if}
    {#if !Device.isPhone && $ConfigStore.customTheme.headerThemeType === HeaderThemeType.multioption}
      <MultiOptionTheme />
    {/if}
    <button
      on:click={() => {
        //state_showSearch.set(false);
        window.dispatchEvent(
          new CustomEvent(WindowsCustomEventTypes.toggleView, { detail: false })
        );
      }}
      style:color={$ConfigStore.customTheme.headerTextColor}
      aria-label={$_('header.toggle_close')}
      title={$_('header.toggle_close')}
      // aria-expanded={true}
      aria-controls={$_('header.toggle_close')}
    >
      <div class="cs-default-icon"><SvgIcon name="chevron-up" /></div>
    </button>
  </div>
</div>

{#if $ConfigStore.customCSSUrl}
  {#if $ConfigStore.customCSSIntegrity}
    <link
      href={$ConfigStore.customCSSUrl}
      rel="stylesheet"
      type="text/css"
      integrity={$ConfigStore.customCSSIntegrity}
      crossorigin="anonymous"
    />
  {:else}
    <link href={$ConfigStore.customCSSUrl} rel="stylesheet" type="text/css" />
  {/if}
{/if}

<style lang="scss">
  @use './../../scss/components/chat-bot-header';
</style>
